import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "DataTable__row DataTable__row_head" }
const _hoisted_4 = ["dataType", "data-sort", "data-order", "onClick"]
const _hoisted_5 = { class: "DataTable_cell_head" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<svg viewBox=\"0 0 24 24\" class=\"sort-icon-default svg-icon\" aria-hidden=\"true\"><use xlink:href=\"#bliss-icon-expand\"></use></svg><svg viewBox=\"0 0 24 24\" class=\"sort-icon-desc svg-icon\" aria-hidden=\"true\"><use xlink:href=\"#bliss-icon-chevron-up-large\"></use></svg><svg viewBox=\"0 0 24 24\" class=\"sort-icon-asc svg-icon\" aria-hidden=\"true\"><use xlink:href=\"#bliss-icon-chevron-down-large\"></use></svg>", 3)
const _hoisted_9 = ["data-clickable", "data-clickable-url"]
const _hoisted_10 = ["href", "data-redirect", "onClick"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["colspan"]
const _hoisted_19 = { class: "DataTable DataTable--flexible DataTable--empty display-flex flex-direction-column justify-content-center" }
const _hoisted_20 = { class: "pl-8 flex-grow-1 display-flex align-items-center" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "title-1 margin-bottom-2" }
const _hoisted_23 = { class: "text-gray-dark" }
const _hoisted_24 = { class: "mt-4 text-center pagination-wrap" }
const _hoisted_25 = {
  class: "pagination",
  "aria-label": "Pagination"
}
const _hoisted_26 = { class: "pagination-list padding-0" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "bliss-button__text" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", null, "...", -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "bliss-button__text" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "bliss-button__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.dtPost)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["DataTableWrapper DataTable--small", 'DataTableWrapper-' + _ctx.dtPost.id + ' ' + ( _ctx.data.database_columns_data.length ? 'DataTable--hoverable DataTable--striped' : '' )]),
          id: `data-datable-wrapper-${_ctx.dtPost.id}`
        
        }, [
          _createElementVNode("table", {
            class: "DataTable",
            id: `data-table-${_ctx.data.data_view.id}`
          }, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.database_columns, (column, index) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: column.column_name,
                    class: _normalizeClass(["DataTable__cell", ['cell-type-' + column.format]]),
                    dataType: column.format,
                    "data-sort": _ctx.sortEnabled(column) ? column.column_name : null,
                    "data-order": _ctx.sortEnabled(column) ? _ctx.sortOrder(column) : '',
                    onClick: ($event: any) => (_ctx.sort(column, index, column.sort.dir))
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", null, _toDisplayString(column.column_title), 1),
                      _hoisted_6
                    ])
                  ], 10, _hoisted_4))
                }), 128))
              ])
            ]),
            (_ctx.displayedItems.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.displayedItems, (row) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row.id,
                    class: "DataTable__row",
                    "data-clickable": row.clickable_element ? 'true' : 'false',
                    "data-clickable-url": row.clickable_element.url ?? null
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: cell.column_name_id
                      }, [
                        (cell.format)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 0,
                              class: _normalizeClass(["DataTable__cell", `cell-type-${cell.format}`])
                            }, [
                              ('status_actions' == cell.format && cell.value)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(cell.value, (action_btn) => {
                                    return (_openBlock(), _createElementBlock("a", {
                                      href: action_btn.url,
                                      "data-redirect": action_btn.result_event ? action_btn.result_event : null,
                                      class: _normalizeClass(["Btn Btn--primary Btn--small", action_btn.headless_module ? 'headless-module' : '']),
                                      onClick: ($event: any) => (_ctx.actionClickHandler($event, action_btn))
                                    }, [
                                      _withDirectives(_createElementVNode("span", {
                                        class: _normalizeClass(action_btn.button_icon )
                                      }, null, 2), [
                                        [_vShow, action_btn.button_type == 'icon-button']
                                      ]),
                                      _createTextVNode(_toDisplayString(action_btn.button_type == 'text-button' ? action_btn.button_text : ''), 1)
                                    ], 10, _hoisted_10))
                                  }), 256))
                                : ('status-badge' == cell.format)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      innerHTML: cell.value
                                    }, null, 8, _hoisted_11))
                                  : (('color-dot' == cell.format && !_ctx.data.downgraded) || 'date' == cell.format || ('download' == cell.format && cell.value))
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 2,
                                        innerHTML: cell.value
                                      }, null, 8, _hoisted_12))
                                    : ('first-8-letters' == cell.format && cell.original_value)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          _createTextVNode(_toDisplayString(cell.value.substring(0, 8)), 1)
                                        ], 64))
                                      : ('long-text-in-two-rows' == cell.format)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 4,
                                            class: "text-two-rows",
                                            innerHTML: cell.value
                                          }, null, 8, _hoisted_13))
                                        : ('long-text' == cell.format)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                              (cell.value)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "long-text",
                                                    innerHTML: cell.value
                                                  }, null, 8, _hoisted_14))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          : ('text' == cell.format)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                                (cell.value)
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 0,
                                                      class: "text",
                                                      innerHTML: cell.value
                                                    }, null, 8, _hoisted_15))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                            : ('width-placeholder' == cell.format)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                                  _createTextVNode(_toDisplayString('<!-- width placeholder -->'))
                                                ], 64))
                                              : (_openBlock(), _createElementBlock("div", {
                                                  key: 8,
                                                  innerHTML: cell.value
                                                }, null, 8, _hoisted_16))
                            ], 2))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ], 8, _hoisted_9))
                }), 128))
              : (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                  _createElementVNode("td", {
                    colspan: _ctx.data.database_columns.length
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        (_ctx.feTheme)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createElementVNode("h2", _hoisted_22, _toDisplayString(_ctx.feTheme.no_data_title ?? 'No data available'), 1),
                              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.feTheme.no_data_text ?? 'There is currently no data to be shown here.'), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 8, _hoisted_18)
                ]))
          ], 8, _hoisted_2)
        ], 10, _hoisted_1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_24, [
      _createElementVNode("nav", _hoisted_25, [
        _createElementVNode("ul", _hoisted_26, [
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              class: "bliss-button bliss-button--theme-default bliss-button--secondary",
              disabled: (_ctx.currentPage <= 1 ) ? true : false,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePage(--_ctx.currentPage)))
            }, [
              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.feTheme.lang__pagination_previous ?? 'Previous'), 1)
            ], 8, _hoisted_27)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryPages, (page, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: page }, [
              (!(index == 0 || ( page - _ctx.summaryPages[index-1] == 1 )))
                ? (_openBlock(), _createElementBlock("li", _hoisted_29, _hoisted_31))
                : _createCommentVNode("", true),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: _normalizeClass(["bliss-button bliss-button--theme-default", (page == _ctx.currentPage) ? 'bliss-button--primary' : 'bliss-button--secondary']),
                  onClick: ($event: any) => (_ctx.changePage(page))
                }, [
                  _createElementVNode("span", _hoisted_33, _toDisplayString(page), 1)
                ], 10, _hoisted_32)
              ])
            ], 64))
          }), 128)),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              class: "bliss-button bliss-button--theme-default bliss-button--secondary",
              disabled: (_ctx.currentPage >= _ctx.pages.length ) ? true : false,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePage(++_ctx.currentPage)))
            }, [
              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.feTheme.lang__pagination_next ?? 'Next'), 1)
            ], 8, _hoisted_34)
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.pagination.enabled && _ctx.pages.length]
    ])
  ], 64))
}